import differenceInCalendarMonths from 'date-fns/differenceInCalendarMonths';
import format from 'date-fns-tz/format';
import subDays from 'date-fns/subDays';

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const monthNumToName = (monthnum) => {
  return months[monthnum - 1] || '';
};

export const getDates = (startMonth, startYear, endMonth, endYear) => {
  if (!startMonth && !startYear) {
    return '';
  }
  const start = `${monthNumToName(startMonth)} ${startYear}`;
  const end = endMonth ? `${monthNumToName(endMonth)} ${endYear}` : `Present`;
  return `${start} - ${end}`;
};

export const toReadableDate = (date, f = 'd MMM yyyy') => {
  return format(new Date(date), f);
};

export const getDuration = (startMonth, startYear, endMonth, endYear) => {
  if (startMonth) {
    let ret, endDate;
    const startDate = subDays(new Date(startYear, startMonth - 1), 1);

    if (endMonth && endYear) {
      endDate = new Date(endYear, endMonth - 1);
    } else {
      endDate = new Date();
    }
    const diff = differenceInCalendarMonths(endDate, startDate);

    const years = Math.floor(diff / 12);
    const months = diff % 12;

    if (years || months) {
      ret =
        ' (' +
        (years ? years + (years === 1 ? ' year' : ' years') : '') +
        (years === 0 ? '' : months ? ' ' : '') +
        (months ? String(months) + (months === 1 ? ' month' : ' months') : '') +
        ')';
    }

    return ret || '';
  }
  return '';
};
